import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBar/SearchBarDesktop";
import { SearchBarMobile } from "./SearchBar/SearchBarMobile";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { BtnXuatDanhSach } from "./XuatDanhSach/BtnXuatDanhSach";
import StoreApi from "service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const DuNoChoVay = () => {
  const initPhanQuyen = {
    dunochovay: true,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenDuNoChoVay().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        dunochovay: response.data.dunochovay,
      });
    });
  };

  useEffect(() => {
    document.title = "Dư nợ cho vay | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.dunochovay && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new hidden-mobile-main">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Dư nợ cho vay</h1>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main">
                        <BtnXuatDanhSach />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                  </div>
                </div>
                <SearchBarMobile />
              </div>
            </div>
          </div>
          <TableDanhSach />
        </div>
      )}
      {!phanQuyen.dunochovay && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new hidden-mobile-main">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Dư nợ cho vay</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
